import {moment} from 'external/moment'
import { Card, FC, useMemo, Badge, Link} from 'external/react'

import PackageItemHeader from './PackageItemHeader'
import SubscriptionStatus from 'components/SubscriptionStatus'

import PackageField from './PackageField'
import SelectUserButton from './SelectUserButton'
import usePackage from 'context/package-context/hook'
import { Package } from 'types/context/package'

type PackageItemProps = {
	index: number,
	item: Package
}

const PackageItem : FC<PackageItemProps> = props => {

	const {index, item} = props

	const {update, state:{ saving}} = usePackage()

	const missingStudent = useMemo(() => item.student === null, [item.student])
	const missingTutor = useMemo(() => item.tutor === null, [item.tutor])
  
   const savingStatus = useMemo(() => (saving[item.id] || {}), [saving, item.id])

   function handleSelectStudent() {
		update({modals: {selectStudent: {$shallow: {
			open: true,
			purchase: {...item, index},
			selectedUser: item.student
		}}}})
   }

   function handleSelectTutor() {
		update({modals: {selectTutor: {$shallow: {
			open: true,
			purchase: {...item, index},
			selectedUser: item.tutor
		}}}})
   }

	return (
		<div className='col-lg-4 col-md-6 mb-3' style={{minWidth: 393}}>
				<Card>
					<PackageItemHeader id={item.id} alias={item.plan_alias} index={index} />
					<Card.Body>
						<div className='form-group row mb-2'>
						<div className='row col-12'>
							<div className='col-lg-3 col-md-3 col-sm-3 col-form-label-sm'>
								<span>Plan</span>
							</div>
							<div className='col-lg-3 col-md-9 col-sm-3'>
								<span>
									<Badge pill bg='light' text='dark' style={{ border: '1px solid #ccc' }} className='text-capitalize' >{item.offerName}</Badge>
								</span>
							</div>
							<div className='col-lg-3 col-md-3 col-sm-3 col-form-label-sm'>
								<span>Estado</span>
							</div>
							<div className='col-lg-3 col-md-9 col-sm-3'>
								<SubscriptionStatus status={item.subscriptionStatus} subscription={item.subscription} />
							</div>
						</div>
						</div>
						<PackageField label='Fecha' value={moment(item.purchaseDate).format('YYYY-MM-DD')} valueClasses={{ configured: true}} />
						<PackageField label='Tutor' value={item.tutor?.name.toUpperCase() ?? 'usuario no asignado'} valueClasses={{ configured: !missingTutor, "missing-config": missingTutor, "has-embedded-right": true }}>
							<SelectUserButton type='tutor' id={item.id} assigned={!missingTutor} assigning={savingStatus.assigning_tutor} onClick={handleSelectTutor}/>
						</PackageField>
						<PackageField label='Estudiante' value={item.student?.name ?? 'usuario no asignado'} valueClasses={{ configured: !missingStudent, "missing-config": missingStudent, "has-embedded-right": true }}>
							<SelectUserButton type='student' id={item.id} assigned={!missingStudent} assigning={savingStatus.assigning_student} onClick={handleSelectStudent} />
						</PackageField>
						<div className='row px-2'>
							<Link className='text-center btn btn-light' to={`/home/packages/${item.id}`}>
								Ver Detalle
							</Link>
						</div>
					</Card.Body>
				</Card>
		</div>
	)
}

export {PackageItem as default}